<template>
  <button
      :type="type"
      :disabled="disabled"
      :class="classObject">
    <span>
      <i :class="firstIconClasses" class="first-icon"
         v-if="iconFirst"></i>
      <slot/>
      <i :class="lastIconClasses" class="last-icon"
         v-if="iconLast"></i>
    </span>
  </button>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  iconFirst: String,
  iconLast: String,
  iconColour: String,
  large: Boolean,
  rounded: Boolean,
  small: Boolean,
  fullWidth: Boolean,
  basicHover: Boolean,
  type: {
    type: String,
    default: 'button'
  },
  btnType: {
    type: String,
    default: 'btn-primary'
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const classObject = computed(() => ({
  [props.btnType] : true,
  'large' : props.large,
  'small' : props.small,
  'full-width': props.fullWidth,
  'rounded' : props.rounded,
  'basic-hover': props.basicHover
}));

const firstIconClasses = computed(() => ({
  ['text-' + props.iconColour] : !!props.iconColour,
  [props.iconFirst] : !!props.iconFirst,
  'icon-start': true
}));
const lastIconClasses = computed(() => ({
  ['text-' + props.iconColour] : !!props.iconColour,
  [props.iconLast] : !!props.iconLast,
  'icon-end': true
}));

</script>